import React from "react";
import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import Toolbar from "@mui/material/Toolbar";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      // minWidth: 0,
      padding: theme.spacing(3),
      paddingTop: 0,
    },
  })
);

interface ContentProps {
  children?: React.ReactNode;
  className?: string;
}

const Content: React.FC<ContentProps> = (props) => {
  const { children, className } = props;
  const classes = useStyles();
  return (
    <main className={clsx(classes.content, className)}>
      <Toolbar
        sx={{
          "@media print": {
            display: "none",
          },
        }}
      />
      {children}
    </main>
  );
};

export default Content;
